import BaseDialog from "./BaseDialog";
import OldInput from "../../form_components/OldInput";

export default class UnitTestDialog extends BaseDialog {
    /**
     * Dialog for unit test
     * @module UnitTestDialog
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.addHandle = this.handleAdd.bind(this);
        this.state = {
            id: props.id,
            name: props.name,
            tests: props.tests
        };
    }

    setConfig(key, value) {
        this.setState({
            [key]: value
        });
    }

    getConfig(key) {
        return this.state[key];
    }

    /**
     * Handle add to module event
     * @param event
     */
    handleAdd(event) {
        if (!this.state.name) {
            window.apm.popupMessage("Name cannot be empty");
            return;
        }
        if (this.state.id) {
            document.dispatchEvent(new CustomEvent("ev-unit-test-rename", {detail: this.state}));
        } else {
            document.dispatchEvent(new CustomEvent("ev-unit-test-create", {detail: this.state}));
        }

        w2popup.close();
    }

    componentDidMount() {
        super.componentDidMount();
        document.addEventListener("ev-dialog-add", this.addHandle);
    }

    unregister() {
        document.removeEventListener("ev-dialog-add", this.addHandle);
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        return (
            <div>
                <div className={"container-fluid element-dialog element-body"}>
                    <div className={"row"}>
                        <div className="col-md-12">
                            <OldInput label="Name" value={this.state.name} context={this} valKey={"name"}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}